<template>
  <q-page class="q-page q-layout-padding items-start pt-0">
    <div id="superset-dashboard" v-if="!homeImage"/>
   <div class="row" v-else >
      <div
        class="bg-white col-lg-12 col-md-12 col-sm-12 col-xl-12 default-border-radius q-layout-padding"
      >
        <div class="row">
          <div class="col-12">
            <div style="position: relative" class="mb-2">
              <div
                class="position-absolute w-75"
                style="
                  top: 50%;
                  left: 0px;
                  transform: translateY(-50%);
                  margin-left: 2rem;
                  color: white;
                "
              >
                <h1>{{ $t("main.title") }}</h1>
                <h2 class="h5 font-weight-normal">{{ $t("main.subtitle") }}</h2>
              </div>

              <img src="../assets/images/graph3.png" class="imageGraph" alt="Graph illustration" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div>
              <img src="../assets/images/graph4.png" class="imageGraph" alt="Graph illustration" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";
import { fetchGuestToken } from "@/store/services/dashboard";
import { Notify } from "quasar";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { supersetConfiguration } from "@/utils/configuration/superset-config";
import store from "@/store";
import { globalConfig } from "@/utils";

export default class Home extends Vue {
  name = "Home-Teamwill";

get daaqUser(){
return store.state.authModule?.user 
        && store.state.authModule?.user.daaqList 
        && store.state.authModule?.user.daaqList[0] 
        && store.state.authModule?.user.daaqList[0].config
        && store.state.authModule?.user.daaqList[0].config.createDAAQ
        ? store.state.authModule?.user.daaqList[0].config.createDAAQ
        : ""
}
get superSetConfig(){
return store.state.authModule && store.state.authModule.superSetConfig
       ? store.state.authModule.superSetConfig
       : undefined
       }
  created() {
    
      let tet = {
                clause: `_daaq = '${this.daaqUser}'` // Template literals make this cleaner
              };
      (supersetConfiguration.guestConfig.rls as any )=[tet]
      let localStorageSupersetConfig : any = undefined
      const superset = localStorage.getItem(globalConfig.storageKeys.supersetConfig)
      if (superset) {
          localStorageSupersetConfig = JSON.parse(superset)
      }
      const superSetConfig = this.superSetConfig || localStorageSupersetConfig
    setTimeout(async () => {
      try {
        const element = document.getElementById("superset-dashboard");
        if (element) {
          await embedDashboard({
            id: superSetConfig?.guestConfig?.resources[0]?.id,
            supersetDomain: superSetConfig?.supersetBasePath, 
            mountPoint: element,
            fetchGuestToken: () => fetchGuestToken(superSetConfig),
            dashboardUiConfig: supersetConfiguration.dashboardUiConfig,
          });
        }
      } catch (e) {
        if (store.state.authModule){
          store.state.authModule.homeImage=true
        }
        console.error(e);
        Notify.create({
          message: "Error initializing the dashboard",
          color: "negative",
        });
      }
    }, 100);
  }
  get homeImage(){
  return store.state.authModule?.homeImage
}
}
</script>
<style>
.imageGraph {
  max-width: 100%;
  max-height: 100%;
  width: 110%;
}
</style>